import ObjectFitImages from "object-fit-images";

const images = document.querySelectorAll(".wide-info-block__image");
ObjectFitImages(images);
